'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = require('react-i18next');

var _components = require('components');

var _utils = require('helpers/utils');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./QuickSendReplyButton.scss');

var QuickSendReplyButton = (_dec = (0, _reactI18next.translate)(['common']), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(QuickSendReplyButton, _Component);

  function QuickSendReplyButton() {
    (0, _classCallCheck3.default)(this, QuickSendReplyButton);
    return (0, _possibleConstructorReturn3.default)(this, (QuickSendReplyButton.__proto__ || (0, _getPrototypeOf2.default)(QuickSendReplyButton)).apply(this, arguments));
  }

  (0, _createClass3.default)(QuickSendReplyButton, [{
    key: 'reply',
    value: function reply(e) {
      (0, _utils.stopEvent)(e);
      this.replyModal.open();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          contentKey = _props.contentKey,
          senderName = _props.senderName;

      var modalProps = { backdrop: true, closeByEsc: true, title: t('Reply') };

      return _react2.default.createElement(
        'span',
        { className: styles.replyBtn, onClick: this.reply, title: t('Reply') },
        _react2.default.createElement('i', { className: 'icon-reply' }),
        _react2.default.createElement(
          _components.Modal,
          (0, _extends3.default)({ ref: function ref(el) {
              return _this2.replyModal = el;
            } }, modalProps),
          _react2.default.createElement(_components.FeedbackForm, { contentKey: contentKey, sender: senderName, compact: true })
        )
      );
    }
  }]);
  return QuickSendReplyButton;
}(_react.Component), _class3.propTypes = {
  contentKey: _propTypes2.default.string,
  senderName: _propTypes2.default.string,
  t: _propTypes2.default.func
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'reply', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'reply'), _class2.prototype)), _class2)) || _class);
exports.default = QuickSendReplyButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/QuickSend/QuickSendReplyButton.js
// module id = 2077
// module chunks = 1